import React, {Component} from "react"

import {InjectIntl, injectIntl} from "@irati/utils/lang"
import FilterCheckboxOption from "@irati/deals/types/FilterCheckboxOption"
import Button from "@irati/ui/src/Button"
import Loading from "@irati/ui/src/Loading"
import idHelper from "@irati/utils/id"
import Flex from "@irati/ui/src/Flex"

import CheckboxOption from "../CheckboxOption"
import {Container, StyledHr, OptionsWrapper} from "./styled"

interface Props extends InjectIntl {
  id?: string
  loadFilterOptions: Promise<void> | null
  options: FilterCheckboxOption[]
  allOptionText: string
  resetButtonText: string
  saveButtonText: string
  disableResetButton: boolean
  disableSaveButton: boolean
  onSelect: () => void
  onSelectAll: () => void
  onReset: () => void
  onSave: () => void
  useExpand?: boolean
  isAllOptionChecked: () => void
}

const Div = (props: Props) => <div {...props} />

class CheckboxGroup extends Component<Props> {
  static defaultProps: Pick<Props, "id"> = {
    id: "checkbox-group"
  }

  shouldAllOptionBeChecked = () => {
    const {options} = this.props
    return !options || options.filter((option) => option.isChecked).length === options.length
  }

  render() {
    const {
      loadFilterOptions,
      options,
      allOptionText,
      isAllOptionChecked,
      resetButtonText,
      saveButtonText,
      disableResetButton,
      disableSaveButton,
      onSelect,
      onSelectAll,
      onReset,
      onSave,
      useExpand,
      id
    } = this.props

    const Wrapper = useExpand ? Container : Div

    return (
      <Wrapper id={id}>
        <OptionsWrapper>
          <CheckboxOption
            id={idHelper("select-all", this.props)}
            value="select-all"
            name={allOptionText}
            checked={isAllOptionChecked ? isAllOptionChecked() : this.shouldAllOptionBeChecked()}
            onClick={onSelectAll}
          />
          {options &&
            options.map(({uuid, name, value, isChecked}: FilterCheckboxOption, i) => (
              <CheckboxOption
                id={idHelper(`option-${i + 1}`, this.props)}
                key={uuid}
                value={value}
                name={name}
                checked={isChecked}
                onClick={onSelect}
              />
            ))}
        </OptionsWrapper>
        <StyledHr />
        <Flex marginTop marginBottom padding={1 / 2} justifyContent="flex-end" alignItems="center">
          <Button small tertiary disabled={disableResetButton} onClick={onReset} marginRight>
            {resetButtonText}
          </Button>
          <Button small disabled={disableSaveButton} primary onClick={onSave}>
            {saveButtonText}
          </Button>
        </Flex>
        <Loading load={loadFilterOptions} useLoader={false} />
      </Wrapper>
    )
  }
}

export default injectIntl(CheckboxGroup)
